import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum AddUserToClientFormErrorStatesEnum {
    RegisterFailed = ErrorStateScheduleEnum.AddUserToClientFormStatesStartIndex
}
